import { BillOfLadingSummary } from './BillOfLadingSummary';

export default BillOfLadingSummary;
